/**
 * Utility function to get the model path based on quality setting
 * 
 * @param {string} modelName - Base model name (e.g., 'phonebox', 'tv', 'news_stand')
 * @param {string} quality - Quality level: 'low_quality', 'medium_quality', or 'original'
 * @returns {string} Full path to the model file
 */
export const getModelPath = (modelName, quality = 'medium_quality') => {
  // Ensure modelName doesn't include path or extension
  const baseName = modelName.replace(/^\/models\//, '').replace(/\.glb$/, '');
  
  // Map quality to folder name
  const qualityFolder = quality === 'original' ? 'original' : quality;
  
  // Return the full path
  return `/models/${qualityFolder}/${baseName}.glb`;
};

/**
 * Get model path from a full path, replacing the quality folder
 * 
 * @param {string} fullPath - Full path like '/models/phonebox.glb'
 * @param {string} quality - Quality level: 'low_quality', 'medium_quality', or 'original'
 * @returns {string} Updated path with quality folder
 */
export const updateModelPath = (fullPath, quality = 'medium_quality') => {
  // Extract model name from path
  const match = fullPath.match(/\/models\/(?:[^/]+\/)?([^/]+\.glb)$/);
  if (!match) {
    // If path doesn't match expected format, return as-is
    return fullPath;
  }
  
  const modelName = match[1];
  return getModelPath(modelName, quality);
};

